var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSchedule(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 10.5C9.25 10.0858 9.58579 9.75 10 9.75H11.5C11.9142 9.75 12.25 10.0858 12.25 10.5C12.25 10.9142 11.9142 11.25 11.5 11.25H10C9.58579 11.25 9.25 10.9142 9.25 10.5Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 4C0.25 1.92893 1.92893 0.25 4 0.25H12C14.0711 0.25 15.75 1.92893 15.75 4V12C15.75 14.0711 14.0711 15.75 12 15.75H4C1.92893 15.75 0.25 14.0711 0.25 12V4ZM4 1.75C2.75736 1.75 1.75 2.75736 1.75 4V12C1.75 13.2426 2.75736 14.25 4 14.25H12C13.2426 14.25 14.25 13.2426 14.25 12V4C14.25 2.75736 13.2426 1.75 12 1.75H4Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.03095 8.97029C8.3235 9.26353 8.32294 9.7384 8.02971 10.031L6.02502 12.031C5.73216 12.3231 5.25803 12.323 4.96533 12.0307L3.97002 11.0367C3.67693 10.744 3.67662 10.2691 3.96932 9.97602C4.26202 9.68294 4.7369 9.68262 5.02998 9.97532L5.49558 10.4403L6.97029 8.96905C7.26353 8.6765 7.7384 8.67706 8.03095 8.97029Z",
    className: "icon-fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 6C9.25 5.58579 9.58579 5.25 10 5.25H11.5C11.9142 5.25 12.25 5.58579 12.25 6C12.25 6.41421 11.9142 6.75 11.5 6.75H10C9.58579 6.75 9.25 6.41421 9.25 6Z",
    className: "icon-fill"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0309 4.47024C8.32348 4.76345 8.32297 5.23833 8.02976 5.5309L6.02542 7.5309C5.73261 7.82308 5.25852 7.82302 4.96578 7.53077L3.97011 6.53678C3.67698 6.24413 3.67658 5.76926 3.96923 5.47612C4.26187 5.18298 4.73675 5.18258 5.02989 5.47523L5.4958 5.94036L6.97024 4.4691C7.26345 4.17652 7.73833 4.17703 8.0309 4.47024Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSchedule);
export default __webpack_public_path__ + "static/media/icon-schedule.4f3533ab6fa76616c724461c7c6316cb.svg";
export { ForwardRef as ReactComponent };